import Parse from '../../parseConfig';

export async function fetchBasePlans() {
  const Plan = Parse.Object.extend('Plan');
  const pageSize = 500;
  const results = [];

  for (let offset = 0; ; offset += pageSize) {
    const query = new Parse.Query(Plan);
    query.limit(pageSize);
    query.skip(offset);
    query.ascending('name');
    query.select(['name', 'inactive']);

    const page = await query.find();
    results.push(...page);
    if (page.length < pageSize) break;
  }

  return results
    .map((plan) => ({
      id: plan.id,
      name: String(plan.get('name') || '').trim() || `Unnamed Plan (${plan.id})`,
      inactive: plan.get('inactive') === 1 || plan.get('inactive') === true,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
